import React, { FC } from 'react';
import { Avatar, Space, Tag, Typography } from 'antd';
import { AvatarProps } from 'antd/lib/avatar/avatar';
import { UserOutlined, TeamOutlined } from '@ant-design/icons';
import Utils from '../../utils/Utils';
const { Text } = Typography;

export const UserAvatar: FC<AvatarProps & { type?: 'user' | 'team' }> = (props) => {
  if (props.src) {
    return (
      <Avatar
        {...props}
        className={Utils.mergeClasses(props.className, 'user-avatar')}
        src={Utils.getFileUrl(props.src as string)}
      />
    );
  }
  return (
    <Avatar
      icon={(props.type ?? 'user') === 'user' ? <UserOutlined /> : <TeamOutlined />}
      {...props}
      className={Utils.mergeClasses(props.className, 'user-avatar')}
    />
  );
};

const UserNameViewPrivate: FC<{
  src?: string;
  name: string;
  position?: string;
  type?: 'user' | 'team';
}> = (props) => {
  return (
    <Space>
      {props.src ? (
        <UserAvatar type={props.type} src={props.src} />
      ) : (
        <Avatar
          icon={(props.type ?? 'user') === 'user' ? <UserOutlined /> : <TeamOutlined />}
          {...props}
          className={'user-avatar'}
        />
      )}
      {!props.position ? (
        props.name
      ) : (
        <Space direction="vertical" size={0}>
          <Text>{props.name}</Text>
          <Text disabled>{props.position}</Text>
        </Space>
      )}
    </Space>
  );
};

export const UserNameView: FC<{
  src?: string;
  name: string;
  tags?: boolean;
  position?: string;
  type?: 'user' | 'team';
}> = (props) => {
  if (props.tags === true) {
    return (
      <Tag style={{ marginBottom: 8, paddingTop: 4, paddingBottom: 4, fontSize: 14 }}>
        <UserNameViewPrivate
          position={props?.position}
          type={props.type}
          name={props.name}
          src={props.src}
        />
      </Tag>
    );
  } else {
    return (
      <UserNameViewPrivate
        position={props?.position}
        type={props.type}
        name={props.name}
        src={props.src}
      />
    );
  }
};
